<template><div><h1 id="zahlungsverbindungen-lsv-dd" tabindex="-1"><a class="header-anchor" href="#zahlungsverbindungen-lsv-dd"><span>Zahlungsverbindungen LSV/DD</span></a></h1>
<p>Zahlungsverbindungen LSV/DD — Basisdaten des Zahlungsempfängers für LSV/DD-Belastungen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Enthält die notwendigen Angaben für die Abwicklung von LSV/DD-Belastungen und -Gutschriften. Pro Zahlungsart (LSV, BAD) muss mindestens eine Zahlungsverbindung erfasst sein.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → LSV/DD → Zahlungsverbindungen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Nummer</dt>
<dd>Zahlungsverbindungsnummer, welche bei der <a class="link" href="ft.refdata.zusfak.html" title="Zusagenfakturierung">Zusagenfakturierung</a> mit LSV oder DD referinziert wird.</dd>
<dt>Mandant</dt>
<dd>Mandant aus Tabelle <a class="link" href="ft.refdata.tblmandant.html" title="Mandanten">Mandanten</a>.</dd>
<dt>Zahlungsmodus</dt>
<dd>&quot;LSV&quot; oder &quot;BAD&quot; aus Tabelle <a class="link" href="ft.refdata.systblzahlmod.html" title="Zahlungsmodi">Zahlungsmodus</a>.</dd>
<dt>Verwendung</dt>
<dd>freies Textfeld zur näheren Bezeichnung der Zahlungsverbindung</dd>
<dt>LSV-ID/RS-PID</dt>
<dd>PID der Post (DD) oder LSV-ID/LSV-Identifikation (LSV). Diese Daten müssen durch das Finanzinstitut bereitgesellt werden.</dd>
<dt>IID</dt>
<dd>IID &quot;Instituts-Identifikation&quot;, ehem. Clearingnummer.</dd>
<dt>Konto-/IBAN-Nummer</dt>
<dd>Kontonummer für den Zahlungseingang, LSV = Bankkonto, BAD = Teilnehmernummer (für beide IBAN verwenden).</dd>
<dt>QR-/ESR-Code</dt>
<dd>Code aus Tabelle <a class="link" href="ft.refdata.tblesr.html" title="QR-/ESR-Rechnunsgparameter">QR-/ESR-Rechnunsgparameter</a></dd>
<dt>Name, Strasse + Nr., Land/PLZ/Ort</dt>
<dd>Adresse des Zahlungsempfängers, die den Zahlungsplichtigen übermittelt wird.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tblesr.html" title="QR-/ESR-Rechnunsgparameter">QR-/ESR-Rechnunsgparameter</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tblmandant.html" title="Mandanten">Mandanten</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.systblzahlmod.html" title="Zahlungsmodi">Zahlungsmodus</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.zusfak.html" title="Zusagenfakturierung">Zusagenfakturierung</RouteLink></p>
</div></template>


